import React from 'react';
import { Star, Check } from 'lucide-react';
import { ImageCarousel } from './ImageCarousel';
const IMAGES = ['https://cdn.magicpatterns.com/uploads/8U6jwPDsPXzUm5bwg9GMyE/ChatGPT_Image_24_ene_2026,_10_43_52_p.m..png', 'https://cdn.magicpatterns.com/uploads/vw9mEeJ7KRTDDvmCYnhDyb/ChatGPT_Image_24_ene_2026,_12_41_35_a.m..png', 'https://cdn.magicpatterns.com/uploads/oAVMLSeX3x7Yt9QGT67eZR/ChatGPT_Image_24_ene_2026,_10_45_55_p.m..png', 'https://cdn.magicpatterns.com/uploads/xaqLvvaU2RydaLARxW973P/ChatGPT_Image_24_ene_2026,_10_49_39_p.m..png'];
const SYMPTOMS = ['Pecho apretado sin razón', 'Mente que no para', 'Despertarte a las 3am', 'Cansada pero acelerada'];
export function HeroSection() {
  return <section className="relative overflow-hidden bg-[#FAF5EF] pt-8 pb-16 lg:pt-16 lg:pb-24" data-id="element-124">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-125">
        {/* Emotional Opening */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-126">
          <h1 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-4 leading-tight" data-id="element-127">
            Recupera tu calma y felicidad diaria.
          </h1>
          <p className="text-xl md:text-2xl text-[#C06B6B] font-medium mb-4" data-id="element-128">
            Aunque hoy tu cuerpo viva en alerta.
          </p>
          <p className="text-base text-gray-500 mb-8" data-id="element-129">
            Protocolo digital · 5 minutos al día · Resultados desde el primer
            uso
          </p>

          {/* Symptom bullets — compact */}
          <div className="grid grid-cols-2 gap-2 max-w-md mx-auto mb-8" data-id="element-130">
            {SYMPTOMS.map((s, i) => <div key={i} className="flex items-center gap-2 bg-white rounded-lg px-3 py-2 border border-[#C06B6B]/10" data-id="element-131">
                <div className="h-1.5 w-1.5 rounded-full bg-[#C06B6B] flex-shrink-0" data-id="element-132" />
                <span className="text-sm text-gray-700" data-id="element-133">{s}</span>
              </div>)}
          </div>

          <p className="text-[#C06B6B] font-medium text-lg" data-id="element-134">
            La buena noticia… Eso se puede reentrenar.{' '}
            <span className="font-bold" data-id="element-135">En 5 minutos.</span>
          </p>
          <p className="mt-2 text-sm text-gray-500 italic" data-id="element-136">
            Sin meditar 30 minutos. Sin afirmaciones. Sin fuerza de voluntad.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16 items-start" data-id="element-137">
          {/* Left Column: Carousel */}
          <div className="relative" data-id="element-138">
            <span className="absolute top-4 left-4 z-10 rounded-full bg-[#C06B6B] px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-white shadow-sm" data-id="element-139">
              Popular
            </span>
            <ImageCarousel images={IMAGES} data-id="element-140" />
          </div>

          {/* Right Column: Product Info */}
          <div className="flex flex-col justify-center" data-id="element-141">
            {/* Reviews */}
            <div className="flex items-center gap-2 mb-4" data-id="element-142">
              <div className="flex text-[#C4973B]" data-id="element-143">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-4 w-4 fill-current" data-id="element-144" />)}
              </div>
              <span className="text-sm font-medium text-gray-600" data-id="element-145">
                4.9/5 · Más de 2,400 mujeres ya lo utilizan
              </span>
            </div>

            {/* Title */}
            <h2 className="text-4xl font-serif font-bold text-gray-900 sm:text-5xl mb-2" data-id="element-146">
              Calma tu Sistema Nervioso en 5 Minutos
            </h2>
            <p className="text-xl text-[#C06B6B] font-medium mb-6" data-id="element-147">
              Con el Protocolo Calma-5™ · Activación Vagal Dirigida™
            </p>

            {/* Price */}
            <div className="flex items-center gap-4 mb-3 p-4 bg-white/50 rounded-xl border border-[#C06B6B]/20 w-fit" data-id="element-148">
              <div data-id="element-149">
                <p className="text-sm text-gray-400 line-through" data-id="element-150">Antes: $47</p>
                <p className="text-3xl font-bold text-gray-900" data-id="element-151">
                  Hoy: $11.99{' '}
                  <span className="text-base font-medium text-gray-500" data-id="element-152">
                    pago único
                  </span>
                </p>
              </div>
            </div>
            <p className="text-xs text-[#C06B6B] font-semibold mb-1" data-id="element-153">
              Ahorras $35 hoy (77% descuento)
            </p>
            <p className="text-xs text-gray-500 mb-6" data-id="element-154">
              📲 Acceso inmediato después del pago · Disponible desde tu
              teléfono
            </p>

            {/* CTA */}
            <a href="https://pay.hotmart.com/Y104339646N?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto rounded-full bg-[#C4973B] px-8 py-4 text-lg font-bold text-white shadow-md hover:bg-[#B08632] hover:shadow-lg transition-all transform hover:-translate-y-0.5 mb-3 text-center inline-block" data-id="element-155">
              👉 Quiero sentir calma en 5 minutos
            </a>

            <p className="text-xs text-gray-400 mb-6 leading-relaxed" data-id="element-156">
              Tu sistema nervioso aprendió a sobrevivir. Calma-5™ le enseña a
              sentirse seguro.
            </p>

            {/* Bonus Preview */}
            <div className="border-t border-gray-200 pt-6" data-id="element-157">
              <p className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2" data-id="element-158">
                <span className="text-lg" data-id="element-159">🎁</span> Incluye 2 Bonos GRATIS
              </p>
              <div className="space-y-2" data-id="element-160">
                <div className="flex items-center gap-2" data-id="element-161">
                  <Check className="h-4 w-4 text-[#C4973B] flex-shrink-0" data-id="element-162" />
                  <span className="text-sm text-gray-600" data-id="element-163">
                    Respiraciones que Calman (60 segundos)
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-164">
                  <Check className="h-4 w-4 text-[#C4973B] flex-shrink-0" data-id="element-165" />
                  <span className="text-sm text-gray-600" data-id="element-166">
                    Rutinas Nocturnas para Dormir Mejor
                  </span>
                </div>
              </div>
            </div>

            {/* Guarantee Badge */}
            <div className="mt-6 flex items-center gap-3 bg-rose-50 border border-rose-200 rounded-xl px-4 py-3 w-fit" data-id="element-167">
              <span className="text-sm font-semibold text-rose-800" data-id="element-168">
                🛡️ Garantía total de 7 días
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}